const colors = {
  black: '#000',
  white: '#FFF',
  star: '#EAB308',
  primary: {
    50: '#FAF5FF',
    100: '#FAF5FF',
    200: '#DFC5FF',
    300: '#B67CFF',
    400: '#790FFF',
    600: '#6100DB',
    800: '#490999',
    900: '#490999',
    950: '#490999',
  },
  success: {
    50: '#ECFDF5',
    100: '#A7F3D0',
    200: '#A7F3D0',
    300: '#52BF9D',
    400: '#059669',
    500: '#0FB380',
    600: '#059669',
    700: '#047857',
    800: '#035A3F',
    900: '#023C2A',
    950: 'yellow', // TODO: Add value from theme.
  },
  danger: {
    50: '#FEF2F2',
    200: '#FECACA',
    300: '#EA7D7D',
    400: '#DC2626',
    500: '#E35151',
    600: '#DC2626',
    700: '#B91C1C',
    800: '#841717',
    900: '#580F0F',
    950: 'yellow', // TODO: Add value from theme.
  },
  warning: {
    50: '#FFF7ED',
    100: '#FFE7CB',
    200: '#FED7AA',
    300: '#F29B6D',
    400: '#EA580C',
    500: '#F1702C',
    600: '#C2410C',
    700: '#C2410C',
    800: '#8C3507',
    900: '#8C3507',
    950: 'yellow', // TODO: Add value from theme.
  },
  info: {
    50: '#EFF6FF',
    100: '#D6E8FF',
    200: '#BFDBFE',
    300: '#7CA1F3',
    400: '#6A96F5',
    500: '#3E75EF',
    600: '#2563EB',
    700: '#1D4ED8',
    800: '#163B8D',
    900: '#0F285E',
    950: 'yellow', // TODO: Add value from theme.
  },
  neutral: {
    50: '#FAFAFA',
    100: '#EFEFEF',
    200: '#EAF0FA',
    300: '#D8DDE8',
    400: '#C6CCD8',
    500: '#737373',
    600: '#6B6B6B',
    700: '#535353',
    800: '#60656F',
    900: '#252525',
    950: '#0A0A0A',
  },
};

export { colors };
